import { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box, Flex, Text, Input, CheckmarkIcon, PencilIcon, IconButton } from '@pancakeswap/uikit'
// import { CalculatorMode, RoiCalculatorReducerState } from './useRoiCalculatorReducer'

const MILLION = 1000000
const TRILLION = 1000000000000

const RoiCardWrapper = styled(Box)`
  border : 1px solid #00FED9;
  width: 100%;
  border-radius: ${({ theme }) => theme.radii.default};
`

const RoiCardInner = styled(Box)`
  // height: 115px;
  padding: 24px;
  border-radius: ${({ theme }) => theme.radii.default};
  background: #1A3342;
`

const RoiInputContainer = styled(Box)`
  position: relative;
  & > input {
    padding-left: 28px;
    max-width: 70%;
  }
  &:before {
    position: absolute;
    content: '$';
    color: ${({ theme }) => theme.colors.textSubtle};
    left: 16px;
    top: 8px;
  }
`

const RoiDisplayContainer = styled(Flex)`
  max-width: 82%;
  margin-right: 8px;
`


const RoiDollarAmount = styled(Text) <{ fadeOut: boolean }>`
  position: relative;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 0px;
  }

  ${({ fadeOut, theme }) =>
    fadeOut &&
    `
      &:after {
        background: linear-gradient(
          to right,
          ${theme.colors.background}00,
          ${theme.colors.background}E6
        );
        content: '';
        height: 100%;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
      }
  `}
`
const StyledInput = styled(Input)`
  box-shadow: none;
  border: 1px solid #00FED9;
  background-color : #1A3342;
  color : white;
  border-radius: 16px;
  width : 150px;
  height : 30px;
  &:focus:not(:disabled) {
    box-shadow: none;
  }
`

interface RoiCardProps {
  tokenRoivalue?: any
  usdRoivalue?: any
  setTokenRoivalue?: any
  setUsdRoivalue?: any
  USDCalculation?: any
  PrincipalCalculation?: any
  inputflag?: any
  setInputFlag?: any
  pool?: any
}

const RoiCard: React.FC<RoiCardProps> = ({ pool,tokenRoivalue, setTokenRoivalue, usdRoivalue, setUsdRoivalue, USDCalculation, PrincipalCalculation, inputflag, setInputFlag }) => {


  const [expectedRoi, setExpectedRoi] = useState('')
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [inputPA, setPAInput] = useState("0");

  useEffect(() => {
    async function setValue() {
      let tknValue = await USDCalculation(1, false);
      let alltnk = (parseFloat(inputPA) / tknValue);
      setTokenRoivalue(alltnk ? alltnk : "0", false);
      PrincipalCalculation(alltnk);
    }
    setValue();
  }, [inputPA]);

  const changePA = (e) => {
    setPAInput(e.target.value);
    setUsdRoivalue(e.target.value);
  }



  return (
    <RoiCardWrapper>
      <RoiCardInner>
        <Text fontSize="12px" color="#00FED9" bold textTransform="uppercase">
          {('ROI at current rates')}
        </Text>
        <Flex justifyContent="space-between" mt="4px" height="36px">
          {/* {mode === CalculatorMode.PRINCIPAL_BASED_ON_ROI ? ( */}
          <>
            {/* <RoiInputContainer>
                <Input
                  ref={inputRef}
                  type="text"
                  inputMode="decimal"
                  pattern="^[0-9]+[.,]?[0-9]*$"
                  scale="sm"
                  value={expectedRoi}
                  placeholder="0.0"
                  // onChange={handleExpectedRoiChange}
                />
              </RoiInputContainer>
              <IconButton scale="sm" variant="text" >
                <CheckmarkIcon color="primary" />
              </IconButton> */}


            {!inputflag ? <RoiDisplayContainer onClick={() => setInputFlag(true)}>
              {/* Dollar sign is separate cause its not supposed to scroll with a number if number is huge */}
              <Text color="white" fontSize="24px" bold>
                $
              </Text>
              <Text color="white" fontSize="24px" bold>{parseFloat(usdRoivalue).toFixed(2)}</Text>
            </RoiDisplayContainer>
              :
              <StyledInput value={inputPA} onChange={changePA} placeholder="0.0" />
            }
            {!inputflag ? <IconButton scale="sm" variant="text">
              <PencilIcon color="#00FED9" onClick={() => setInputFlag(true)} />
            </IconButton>
              :
              <IconButton scale="sm" variant="text" >
                <CheckmarkIcon color="#00FED9" onClick={() => setInputFlag(false)} />
              </IconButton>
            }
          </>

        </Flex>
        <Text fontSize="12px" color="#B1B3CB">
          ~{parseFloat(tokenRoivalue).toFixed(2)} DVX ({(pool.apy.toFixed(2))}%)
        </Text>
      </RoiCardInner>
    </RoiCardWrapper>
  )
}

export default RoiCard
